import React from 'react';
import { pizzasDocesData } from '../data/menuData';
import { Item } from '../styles/styles.js';

const sizeLabels = ['P', 'M', 'G', 'F'];
const sizeColors = [
  'bgcolor-size1',
  'bgcolor-size2',
  'bgcolor-size1',
  'bgcolor-size3',
];

const PizzasDoces = () => (
  <>
    {pizzasDocesData.map(categoryGroup => (
      <React.Fragment key={categoryGroup.category}>
        {categoryGroup.items.map((pizza, index) => (
          <Item key={pizza.id} firstItem={index === 0}>
            <div className="item-separator">
              <h4 className="item-title">
                {pizza.promo && <span className="badge">Promoção</span>}
                {pizza.id} - {pizza.name}
              </h4>
              <p className="item-desc">{pizza.desc}</p>
            </div>

            <div className="item-price-container">
              {pizza.prices.map((price, i) => (
                <div className="item-price-wrapper" key={i}>
                  <div className={`item-price-size ${sizeColors[i]}`}>
                    <p>{sizeLabels[i]}</p>
                  </div>
                  <div className="item-price">
                    <p>{price}</p>
                  </div>
                </div>
              ))}
            </div>
          </Item>
        ))}
      </React.Fragment>
    ))}
  </>
);

export default PizzasDoces;
